import { useClearFilters } from 'src/modules/search/hooks';
import i18n from 'src/utils/translate';
import { LinkButton } from 'styles-js/buttons';

type Props = {
  onClick?: () => void,
}
export default function ClearFilters({ onClick }: Props): JSX.Element {
  const clearFilters = useClearFilters();

  const onClickExtended = () => {
    clearFilters();
    if (onClick) onClick();
  };

  return (
    <LinkButton onClick={onClickExtended}>
      {i18n.t('Clear filters')}
    </LinkButton>
  );
}
